import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "./routes"
import { useAuthStore } from "@/stores/auth"
import { AUTHTOKEN } from '@/constants';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes, /* eslint-disable */
  scrollBehavior(to, from, savedPosition) {
   
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
   
   
  },
})
// nasna
router.beforeEach(async (to, from, next) => {
  if (to.fullPath.includes("?phoneNumber=")) {
    return next({
      name: 'subscribe_ok',
      params: {
        phoneNumber: to.query.phoneNumber
      }
    });
  }

  const TOKEN = localStorage.getItem(AUTHTOKEN);

  if (to.name === 'subscribe_ok') {
    var phone = to.params.phoneNumber.substring(to.params.phoneNumber.indexOf('=') + 1);
    const auth = useAuthStore();
    await auth.checkSubescriptionStatus(phone);
    return next();
  }

  if (to.meta.auth && TOKEN === null) {
    return next({ name: 'subscribe.header' });
  }

  if (to.meta.auth && TOKEN !== null) {
    return next();
  }

  if (to.meta.auth === false) {
    return next();
  }

  next();
});



export default router
